import { SelectElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { YoutubeSettingsDtoPrivacyStatusEnum } from '../../social-export.types';

export function YoutubePrivacyStatusField() {
  const { $t } = useIntl();
  return (
    <SelectElement
      name="privacyStatus"
      label={$t({
        id: 'youtube.privacyStatus.label',
        defaultMessage: 'Estado de privacidad',
      })}
      options={[
        {
          id: YoutubeSettingsDtoPrivacyStatusEnum.private,
          label: $t({
            id: 'youtube.privacyStatus.private',
            defaultMessage: 'Privado',
          }),
        },
        {
          id: YoutubeSettingsDtoPrivacyStatusEnum.public,
          label: $t({
            id: 'youtube.privacyStatus.public',
            defaultMessage: 'Público',
          }),
        },
        {
          id: YoutubeSettingsDtoPrivacyStatusEnum.unlisted,
          label: $t({
            id: 'youtube.privacyStatus.unlisted',
            defaultMessage: 'No listado',
          }),
        },
      ]}
      fullWidth
      required
    />
  );
}
